export const FEATURE_FLAGS = {
  NUXT_FOUR: 'nuxt-four',
  LEADS_MANAGEMENT: 'leads-management',
};
